import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { TreeNode } from 'primeng/api';
import { ModelType } from '@shared/constants/model-type.enum';
import { ModelOutputFile } from '@models/model-output-file.model';
import { FileModel } from '@models/file.model';
import { VariableOutputModel } from '@models/variable-output-model';

@Injectable({
  providedIn: 'root'
})
export class DataPropertiesService {

  constructor(private apiService: ApiService) { }

  getDataProperties(projectId: number, modelType: ModelType): Observable<TreeNode[]> {
    return this.apiService.get(`data-properties/${projectId}`, modelType);
  }    

  getVariablesData(projectId: number, modelType: ModelType): Observable<VariableOutputModel[]> {
    return this.apiService.get(`variable-output/${projectId}`, modelType);
  }  

  getEgModelOutputFile(fileId: number, modelType: ModelType): Observable<ModelOutputFile> {
    return this.apiService.get(`model-output-file/${fileId}`, modelType);
  }

  getFile(fileId: number, modelType: ModelType): Observable<FileModel> {
    return this.apiService.get(`source-data-file/${fileId}`, modelType)
  }
}